import React,{useState,useRef} from 'react';
import { createUseStyles } from 'react-jss';
import './Directory.css';
import { Container,Row,Col, Modal, Button,Badge,Form, Table } from 'react-bootstrap';
import { RightSidebar } from '../RightSidebar/RightSidebar';

import { setDataDb } from '../../http/petitions';

import moment from "moment";
import "moment/locale/es";
import { useEffect } from 'react';
moment.locale("mx");

const styles = createUseStyles( theme => (
  {
    backgroundPrimary:{
      backgroundColor: theme.colorPrimary,
      '& .ws-directory-sidebar-list-badge p':{
        background: '#fff !important',
        color: theme.colorPrimary
      }
    },
    box: {
      backgroundColor: '#ffffff',
    },
    push: {
      cursor: 'pointer',
    },
    newClient: {
      cursor: 'pointer',
      fontStyle: 'italic',
      fontSize: '.8rem',
      fontWeight: '800',
      padding:'10px 5px',
      backgroundColor:'#ededed',
      margin:'10px 0px',
      borderRadius:'4px',
      textAlign: 'center',
      fontFamily: 'Open sans',
    },
    NombreCliente:{
      color: theme.colorPrimary
    },
    ListBadge:{
      background: `${theme.colorPrimary} !important`
    },
    ListItemActive:{
      backgroundColor: theme.colorPrimary,
      border: `2px solid ${theme.colorPrimary}`,
      cursor: 'pointer',
      '& p':{
        color:'#fff !important'
      },
      '& .ws-directory-sidebar-list-badge p': {
        background:'#fff !important',
        color: `${theme.colorPrimary} !important`
      },
      '&:hover':{
        backgroundColor: theme.colorPrimary,
        border: `2px solid ${theme.colorPrimary}`,
      }
    },
    inputLarge: {
      width: '100%',
      border: '2px solid #ccc',
      backgroundColor: '#f3f3f3',
    },
  
    p: {
      margin: 0,
    },
  
    LinkTab:{
      lineHeight:'35px',
      fontWeight:'700',
      fontSize:'1.1rem'
    },
  
    LinkTabActive:{
      color: theme.colorPrimary
    },
    ColorIcon:{
      color: `${theme.colorPrimary} !important`
    },
    SpinnerColor:{
      borderLeftColor: theme.colorPrimary
    },
    ProfileImage:{
      border: `4px solid ${theme.colorPrimary}` 
    },
    ProfileName:{
      color: theme.colorPrimary
    },
    ProfileDeleteIcon:{
      color: theme.colorPrimary
    },
    ProfileSeparator:{
      borderBottom: `2px solid ${theme.colorPrimary}`
    },
    ProfileSeparatorIcon:{
      background: `${theme.colorPrimary} !important`
    },
    BtnPrimary:{
      background: `${theme.colorPrimary} !important`,
      borderColor: `${theme.colorPrimary} !important`,
      '&:hover':{
        background: `${theme.colorPrimary} !important`,
        borderColor: `${theme.colorPrimary} !important`
      }
    },
    TabsPolizasBoxLeft:{
      border: '1px solid #d1d1d1',
      cursor: 'pointer',
      paddingTop: '6px',
      paddingBottom: '6px',
      borderTopLeftRadius: '3px',
      borderBottomLeftRadius: '3px',
      '& b':{
        fontWeight: '700',
        fontSize: '1.1rem',
      },
      '&:hover':{
        backgroundColor:'#ededed'
      },
      '&.active':{
        backgroundColor:'#ededed'
      }
    },
    TabsPolizasBoxRight:{
      border: '1px solid #d1d1d1',
      cursor: 'pointer',
      paddingTop: '6px',
      paddingBottom: '6px',
      borderTopRightRadius: '3px',
      borderBottomRightRadius: '3px',
      borderLeft:'none',
      '& b':{
        fontWeight: '700',
        fontSize: '1.1rem',
      },
      '&:hover':{
        backgroundColor:'#ededed'
      },
      '&.active':{
        backgroundColor:'#ededed'
      }
    },
    TabsPolizasText:{
      color: '#444',
      '&.active':{
        color: `${theme.colorPrimary} !important`
      }
    },
    DataColumn:{
      // borderLeft: '1px solid #ededed'
    },
    RamosList:{

    },
    RamosListNombre:{
      whiteSpace: 'wrap',
      '&.hide':{
        paddingLeft:'0px'
      }
    },
    ExpandIcon:{
      position: 'absolute',
      width: '0',
      height: '0',
      borderTop: '15px solid transparent',
      borderBottom: '15px solid transparent',
      borderRight: `15px solid ${theme.colorPrimary}`,
      marginTop: '3px',
      marginLeft: '-26px',
      cursor: 'pointer',
    },
    CloseButton:{
      borderBottom: '1px solid #ededed',
      lineHeight: '55px',
      transition: 'background 0.5s ease',
      '&:hover':{
        backgroundColor:'#ededed'
      }
    },
    TitleViewDetail:{
      fontWeight: '800',
      fontSize:'1.5rem',
    },
    TitleTableDetail:{
      fontWeight: '700',
      // borderBottom:'1px solid #f3f3f3',
    },
    PriceTableDetail:{
      fontFamily: 'Open sans',
      fontSize:'1.2rem'
    },
    TextTableDetail:{
      fontFamily: 'Open sans',
      fontSize:'1rem'
    },
    MonedaTableDetail:{
      fontFamily: 'Open sans',
      fontSize:'1rem'
    },
    LabelTagSuccess:{
      fontFamily: 'Open sans',
      fontSize: '.9rem',
      letterSpacing: '-1px',
      overflowWrap: 'break-word',
      fontWeight: '400',
      background: 'green',
      textAlign: 'center',
      color:' #fff',
      borderRadius: '4px',
      padding: '2px',
      width: '84%',
      margin: '0 auto',
    },
    LabelTagDanger:{
      fontFamily: 'Open sans',
      fontSize: '.9rem',
      letterSpacing: '-1px',
      overflowWrap: 'break-word',
      fontWeight: '400',
      background: '#df3444',
      textAlign: 'center',
      color:' #fff',
      borderRadius: '4px',
      padding: '2px',
      width: '84%',
      margin: '0 auto',
    },
    LabelTagWarning:{
      fontFamily: 'Open sans',
      fontSize: '.9rem',
      letterSpacing: '-1px',
      overflowWrap: 'break-word',
      fontWeight: '400',
      background: '#f9c31f',
      textAlign: 'center',
      color:' #fff',
      borderRadius: '4px',
      padding: '2px',
      width: '84%',
      margin: '0 auto',
    },
    MenuIconList:{
      fontSize: '2rem',
      color: '#777',
      cursor: 'pointer',
      opacity: '1',
  },
  MenuIconSubList:{
      lineHeight: 'normal !important',
      position: 'relative',
      top: '7px',
      left: '-4px',
      fontSize: '1.5rem',
  },
  SubMenuList:{
      textAlign: 'left',
      borderRadius: '3px',
      backgroundColor: '#fff',
      boxShadow: '0 1px 7px 0 rgb(0 0 0 / 10%)',
      position: 'absolute',
      // left: '0',
      zIndex: '9',
      opacity: '0',
      visibility: 'hidden',
      width: '200px',
      transition:' all 0.25s ease-out',
      left: '-150px !important',
      padding:'0px',
      '& li':{
          listStyle:'none'
      }
  },
  SubMenuListItem:{
    padding:'6px 10px',
    '&:hover':{
      backgroundColor: theme.colorPrimary,
      color: '#fff',
      cursor:'pointer'
    }
  },
  OptionList:{
      '&:hover > ul':{
          opacity:'1',
          visibility:'visible'
      }
  },

  
  }
))

export const Directory = () => {

  const classes = styles();

  const refTelefono = useRef(null);
  const refCorreo = useRef(null);
  const refFechaNacimiento = useRef(null);
  const refRfc = useRef(null);
  const refCalle = useRef(null);
  const refColonia = useRef(null);
  const refNumeroExterior = useRef(null);
  const refCiudad = useRef(null);
  const refEstado = useRef(null);
  const refCp = useRef(null);
  const refLugarTrabajo = useRef(null);

  // SECCIÓN DE BÚSQUEDA
  const [sectionDirectory,setSectionDirectory] = useState({
    view: 'clientes',
    value: '',
    indexCliente: -1,
    // indexCliente: 0, // Dejar luego en -1
    arr: [],
    // fichaCliente: {},
    // fichaRamo: [],
    // datosContrato: {},
    // indexRamo: 0,
    // id_ramo: '',
    fichaNuevaPoliza: { },
    results: true,
    editCliente:false,
  });

  // REGISTRAR NUEVO CLIENTE
  const initFormClient = {
    register: false,
    nombre: '',
    paterno: '',
    materno: '',
    phone: '',
    email: '',
    birthday: '',
    inputs: [],
  }

  // Pensando si se va a usar
  // const initFormFichaPoliza = { register: false, }

  const [formNewClient,setFormNewClient] = useState(initFormClient);
  const [tabContratos,setTabContratos] = useState(1);
  const [tabPoliza,setTabPoliza] = useState(2);
  const [showSidebarRight,setShowSidebarRight] = useState(false);
  const [initSearch,setInitSearch] = useState(false);
  const [minimizeSidebar,setMinimizeSidebar] = useState(false);

  // Modal agregar nuevo contrato
  // const [show, setShow] = useState(false);
  // Modal eliminar contrato
  const [showDeletePoliza, setShowDeletePoliza] = useState({
    index: -1,
    id_motivo: '',
    observacion: '',
  });

  function onChangeSearchClient(ev) {

    if(ev.key === 'Enter') {

      setInitSearch(true);

      const data = {
        val: sectionDirectory.value,
        type: 'clientes',
      }
      fetch('REST/controllers/directoryController?opt=searchInDirectory',{
        method:'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {
        if(response.service) {
          sectionDirectory.arr = response.lista
          sectionDirectory.results = response.lista.length > 0 ? true : false
          setSectionDirectory({...sectionDirectory,});
          setInitSearch(false);
        }
      })

    }

  }

  function setSelectCliente(index) {
    const { id_usuario, nombre, } = sectionDirectory.arr[index]

    const data = {
      id_usuario,
      nombre,
    }

    fetch('REST/controllers/directoryController?opt=getPerfilUsuario',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      sectionDirectory.indexCliente = index
      sectionDirectory.fichaCliente = response
      setSectionDirectory({...sectionDirectory,})
    })
  }

  function setSelectRamo(index, fromTab, optTab) {

    setMinimizeSidebar(true);

    // Obtener id_usuario seleccionado
    const { indexCliente, arr, } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]

    const { selected, id_padre, } = sectionDirectory.fichaCliente.contratos[index]

    if(!fromTab) {
      sectionDirectory.fichaCliente.contratos.map((t,e) => t.selected = false)
      setSectionDirectory({...sectionDirectory})

      // Si el ramo nunca ha sido seleccionado lo habilitamos
      if(!selected) {
        delete sectionDirectory.datosContrato
        sectionDirectory.fichaCliente.contratos[index].selected = true
        sectionDirectory.indexRamo = index
        sectionDirectory.id_ramo = id_padre
        sectionDirectory.fichaRamo = []
        setSectionDirectory({...sectionDirectory,})
      } else {
        delete sectionDirectory.fichaRamo
        delete sectionDirectory.indexRamo
        delete sectionDirectory.id_ramo
        delete sectionDirectory.datosContrato
        setSectionDirectory({...sectionDirectory,})
        return false
      }
    }

    const data = {
      id_usuario,
      id_padre,
      status: fromTab ? optTab : tabContratos,
    }

    fetch('REST/controllers/directoryController?opt=obtenTablaContratos',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      sectionDirectory.fichaRamo = response.contratos
      setSectionDirectory({...sectionDirectory,})
    })
  }

  function setDownloadXLS() {
    const { indexCliente, arr, } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]

    const data = {
      id_usuario,
    }

    fetch('REST/controllers/directoryController?opt=exportPolizasByCliente',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      window.open(response, '_blank')
    })
  }

  function setDeleteCliente() {
    //[EM] Agregar una mejor vista de diseño

    if(!window.confirm("¿Estás seguro de borrar este cliente?\nEsta acción no se puede deshacer y toda las pólizas también serán removidas."))
      return false


    const { indexCliente, arr, } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]

    if(id_usuario === '62c62803224be') {
      alert('Este usuario no se puede borrar.')
      return false
    }

    const data = {
      id_usuario,
    }

    fetch('REST/controllers/directoryController?opt=deleteCliente',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      sectionDirectory.arr.splice(indexCliente, 1)
      sectionDirectory.indexCliente = -1
      delete sectionDirectory.fichaCliente
      setSectionDirectory({...sectionDirectory})
    })
  }

  function setOpenRegisterNewClient() {
    setFormNewClient({
      ...initFormClient,
      register: true,
    })

    fetch('REST/controllers/directoryController?opt=getFormProspecto',{
      method:'post',
      mode:'cors',
    })
    .then( response => response.json() )
    .then( response => {
      
      setFormNewClient({
        ...formNewClient,
        register: true,
        inputs: response.inputs,
      })
    })
  }

  function setRegisterNewClient() {
    const { nombre, paterno, materno, phone, email, birthday, inputs, } = formNewClient

    //[EM] Adaptar toast en lugar de alert
    if( nombre === '' || paterno === '' || materno === '' || phone === '' || email === '' || birthday === '') {
      alert('Para registrar este cliente es necesario rellenes los datos nombre, teléfono, correo y fecha de nacimiento.')
      return false
    }

    const data = {
      name: nombre,
      apaterno: paterno,
      amaterno: materno,
      phone: phone,
      mail: email,
      //[EM] Formatear fecha correctamente 'YYYY-MM-DD'
      fecha: '0000-00-00',
      obj: inputs,
    }

    fetch('REST/controllers/directoryController?opt=setRegisterProspecto',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data),
    })
    .then( response => response.json() )
    .then( response => {

      // Obtenemos el ID del prospecto
      const { id_usuario, } = response
      const nombreCompleto = `${nombre} ${paterno} ${materno}`;


      // Se reinicia el formulario y se oculta la vista de "registrar nuevo cliente"
      setFormNewClient({ ...initFormClient, })

      //Escribimos el nombre en el buscador...
      sectionDirectory.value = nombreCompleto
      setSectionDirectory({...sectionDirectory,})

      // Se consulta a la BD los clientes con ese nombre completo
      const data = {
        val: nombreCompleto,
        type: 'clientes',
      }
      fetch('REST/controllers/directoryController?opt=searchInDirectory',{
        method:'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {
        if(response.service && response.lista.length > 0) {
          sectionDirectory.arr = response.lista
          sectionDirectory.results = response.lista.length > 0 ? true : false
          setSectionDirectory({...sectionDirectory,})

          // Encontramos el perfil basado en el ID devuelto al registrar el nuevo cliente y simulamos un "auto presionado"
          sectionDirectory.arr.map((item, index) => {
            if(item.id_usuario === id_usuario) {
              setSelectCliente(index)
              return true;
            }

            return true
          })
        }
      })

    })
  }

  function setVerPagos(index) {
    const { indexCliente, arr, fichaRamo, } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]
    const { id_contrato, } = fichaRamo[ index ]

    const data = {
      id_usuario,
      id_contrato,
    }

    delete sectionDirectory.datosContrato
    setSectionDirectory({...sectionDirectory})

    fetch('REST/controllers/directoryController?opt=getViewContrato',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.service) {
        sectionDirectory.datosContrato = response
        setSectionDirectory({...sectionDirectory})
      }
    })
  }

  function setEditPolizaExtra() {
    const { datosContrato } = sectionDirectory
    const editExtra = datosContrato.editExtra

    datosContrato.editExtra = !datosContrato.editExtra
    setSectionDirectory({ ...sectionDirectory })
    if(editExtra) {
      //Guardamos cambios

      const { extra, configuracion } = datosContrato
      let arr = []
      extra.map((t,e) => {
        arr.push({
          id_dato: null,
          valor: t.nombre,
          id_padre: t.id_padre,
        })
        return true
      })

      const data = {
        id_poliza: configuracion.id_poliza,
        adicional: arr,
      }

      fetch('REST/controllers/directoryController?opt=wiActualizaAdicionalPoliza',{
        method:'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {
        if(response.service) {
          //[EM] Cambiar a toaster
          alert('Datos cambiados con éxito')
        }
      })

    }

  }

  function setEditPolizaObservacion() {
    const { datosContrato } = sectionDirectory
    const editObservaciones = datosContrato.editObservaciones

    datosContrato.editObservaciones = !datosContrato.editObservaciones
    setSectionDirectory({ ...sectionDirectory })
    if(editObservaciones) {
      //Guardamos cambios

      const { configuracion, } = datosContrato
      
      const data = {
        id_poliza: configuracion.id_poliza,
        observacion: configuracion.observacion,
      }

      fetch('REST/controllers/directoryController?opt=wiActualizaObservacionPoliza',{
        method:'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {
        if(response.service) {
          //[EM] Cambiar a toaster
          alert('Observaciones actualizadas con éxito')
        }
      })

    }

  }

  function setCancelar(opt, index) {
    if(opt === 1) {
      setShowDeletePoliza({ index, id_motivo: '', observacion: '', })
    } else {
      const { fichaRamo, } = sectionDirectory
      const { id_contrato, } = fichaRamo[ index ]
      const { id_motivo, observacion, } = showDeletePoliza

      const data = {
        option: id_motivo,
        val: observacion,
        id_contrato,
      }

      fetch('REST/controllers/directoryController?opt=setCancelPoliza',{
        method:'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {
        setSelectRamo( sectionDirectory.indexRamo, true, 1 )
        setShowDeletePoliza({ index: -1, id_motivo: '', observacion: '', })
        //[EM] Poner toaster
        alert('Póliza eliminada con éxito')
      })
    }
  }

  function setRenovar(index) {
    const { indexCliente, arr, fichaRamo, } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]
    const { id_contrato, } = fichaRamo[ index ]

    const data = {
      id_usuario,
      id_contrato,
    }

    fetch('REST/controllers/directoryController?opt=getViewContrato',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.service) {
        setRegistrarNuevaPoliza(response);
        handleShowRightSidebar();
      }
    })

  }

  function setDeleteNubePoliza(index) {
    const { id_subida, } = sectionDirectory.datosContrato.nube[index]
    const data = {
      id_subida,
    }

    fetch('REST/controllers/cloudController?opt=goToDeletePoliza',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      sectionDirectory.datosContrato.nube.splice(index, 1)
      setSectionDirectory({...sectionDirectory})
    })

  }

  function setDownloadNube(index) {
    const { id_subida, } = sectionDirectory.datosContrato.nube[index]
    const data = {
      id_subida,
    }

    fetch('REST/controllers/cloudController?opt=goToDownloadPoliza',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      window.open(response, '_blank')
    })

  }

  function setPolizaMarcaPago(index) {
    const { configuracion, } = datosContrato
    const { numero_poliza, numero_renovacion, compania, } = configuracion
    const { id_historial, } = datosContrato.contratos[index]

    let { estado, } = datosContrato.contratos[index]

    /**
     * Se define de esta forma por que puede que el recibo sea:
     * [0] => El servidor en automatico lo marcó como no funcional
     * [2] => No se ha pagado aún
    */
    if(estado !== 1)
      estado = 1
    else
      estado = 2

    // Si el consumo es 1 será marcar pago
    let data = {}
    if(estado === 1) {
      data = {
        id_historial,
        opt: 1, // Este define si se notifica al cliente o no
        email: '',
        nombre_cliente: '',
        numero_poliza,
        tipo_pago: numero_renovacion,
        agente: '',
        compania,
      }
    } else {
      data = { id_historial, }
    }

    fetch(`REST/controllers/mainController?opt=${estado === 1 ? 'marcarPago' : 'quitarPago'}`,{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      datosContrato.contratos[index].estado = estado
      setSectionDirectory({...sectionDirectory})
    })

  }

  function setRegistrarNuevaPoliza(dataRenovation) {
    const { id_ramo, } = sectionDirectory

    const data = {
      id_ramo,
    }
    fetch(`REST/controllers/directoryController?opt=prepareNewContrato`,{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.service) {
        sectionDirectory.fichaNuevaPoliza = { ...response, step: 1, fecha_inicio: moment().format('YYYY-MM-DD'), fecha_fin: moment().add(1, 'Y').format('YYYY-MM-DD') }

        if(dataRenovation) {
          const { configuracion, extra, agentes, } = dataRenovation
          const { forma_pago, numero_renovacion, numero_poliza, fecha_fin_text, prima_total, prima_neta, id_compania, observacion, id_poliza, } = configuracion
          const fecha_fin_newYear = moment(fecha_fin_text).add(1, 'Y').format('YYYY-MM-DD')

          let newArrAgentes = response.agentes
          agentes.map((t,e) => {
            newArrAgentes.map((t0,e0) => {
              if( t.id_clave === t0.id_clave )
                newArrAgentes[e0].selected = true
              return true
            })
            return true
          })

          let newExtra = response.extra
          extra.map((t,e) => {
            newExtra.map((t0,e0) => {
              if( t.id_padre === t0.id_hijo )
                newExtra[e0].value = t.nombre
              return true
            })
            return true
          })

          sectionDirectory.fichaNuevaPoliza = {
            ...sectionDirectory.fichaNuevaPoliza,
            renovation: 1, //Esto define que el tipo es renovación
            id_contrato_hold: id_poliza,
            forma_pago: numero_renovacion.charAt(0).toLowerCase(),
            concepto: forma_pago,
            numero_poliza,
            fecha_inicio: fecha_fin_text,
            fecha_fin: fecha_fin_newYear,
            prima_total: prima_total.replace(/,/g, ''),
            prima_neta: prima_neta.replace(/,/g, ''),
            compania: id_compania,
            agentes: newArrAgentes,
            extra: newExtra,
            observacion,
          }
        }

        setSectionDirectory({...sectionDirectory})
      }
    })

  }

  function setNuevaPolizaStep(opt) {
    const { fichaNuevaPoliza, } = sectionDirectory
    const { forma_pago, fecha_inicio, /*fecha_fin,*/ prima_total, } = fichaNuevaPoliza
    let iteraciones = [0, 0]
    if(forma_pago === 'm')
      iteraciones = [12, 1]
    if(forma_pago === 's')
      iteraciones = [2, 6]
    if(forma_pago === 't')
      iteraciones = [4, 3]
    if(forma_pago === 'a')
      iteraciones = [1, 12]


    let fecha_recibo = moment(fecha_inicio).format('YYYY-MM-DD'),
    arrRecibosPagos = [],
    costo_unitario = parseFloat(prima_total) / iteraciones[0]
    for(var a = 0; a < iteraciones[0]; a++) {
      if(a > 0)
        fecha_recibo = moment(fecha_recibo).add(iteraciones[1], 'M').format('YYYY-MM-DD');

      arrRecibosPagos.push({
        id: (a + 1),
        fecha: fecha_recibo,
        pgracia: a === 0 ? fecha_recibo : '',
        // [EM] Costo que devuelva solo devolver 2 decimales
        valor: costo_unitario,
      })
    }

    fichaNuevaPoliza.step = opt
    fichaNuevaPoliza.recibos = arrRecibosPagos
    setSectionDirectory({ ...sectionDirectory, })
  }

  function setRegisterNuevaPolizaEnd() {
    const { fichaNuevaPoliza, id_ramo, indexCliente, arr, } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]
    const {
      numero_poliza, forma_pago, fecha_inicio, fecha_fin, prima_total, prima_neta,
      concepto, compania, agentes, recibos, extra, observacion, renovation, id_contrato_hold,
    } = fichaNuevaPoliza

    let arrAgentes = []
    agentes.map((t,e) => {
      if(t.selected)
        arrAgentes.push({ id_agente: t.id_clave })
      return true
    })
    let arrExtra = []
    extra.map((t,e) => {
      if(t.value)
        arrExtra.push({
          id_ramo,
          valor: t.value,
          id_hijo: t.id_hijo,
        })
      return true
    })


    const data = {
      obj: {
        id_usuario,
        id_ramo,
        numero: numero_poliza,
        finicio: fecha_inicio,
        ffin: fecha_fin,
        primatotal: prima_total,
        primaneta: prima_neta,
        fpago: forma_pago,
        concepto,
        company: compania,
        agentes: arrAgentes,
        recibos,
        extra: arrExtra,
        observacion,
        notify: 0, //[EM], no borres esto, por defecto no notificaremos
        // email_nombre: "Jesus Yanez Mar",
        // email_concepto:"Mensual",
        // email_compania:"QUÁLITAS",
        // email_prima:"$1,000.00",
        id_agente: arrAgentes.length === 0 ? '' : arrAgentes[0].id_agente,
        renovation: !renovation ? 0 : renovation,
        id_contrato_hold: !id_contrato_hold ? '' : id_contrato_hold,
        moneda: "mxn",
      }
    }

    fetch('REST/controllers/directoryController?opt=setContratoNuevo',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.service) {
        setSelectRamo( sectionDirectory.indexRamo, true, 1 )
        // [EM] Falta poner toast
        setShowSidebarRight(false);
        alert('¡La póliza se generó con éxito!')
      }
    })
    
  }

  const handleShowRightSidebar = () => {
    setShowSidebarRight(!showSidebarRight);
  }

  const handleSaveFichaCliente = () => {
    const { indexCliente, arr } = sectionDirectory
    const { id_usuario, } = arr[ indexCliente ]
    let parent  = {
      nomb : clienteParent.nombre,
      paterno : clienteParent.paterno,
      materno  : clienteParent.materno,
      birthday : clienteParent.birthday,
      phone : clienteParent.phone,
      email : clienteParent.email,
    }
    parent = JSON.stringify(parent);
    let obj = JSON.stringify(clienteObj);
    var formData = new FormData();
    formData.append('id_usuario', id_usuario);
    formData.append('obj',obj);
    formData.append('parent',parent);
    setDataDb(formData,'directoryController','setEdicionInformacionCliente')
    .then( response => {
      console.log(response);
    })

    const data = {
      val: sectionDirectory.value,
      type: 'clientes',
    }
    fetch('REST/controllers/directoryController?opt=searchInDirectory',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.service) {
        sectionDirectory.arr = response.lista
        sectionDirectory.results = response.lista.length > 0 ? true : false
        setSectionDirectory({...sectionDirectory,});
        setInitSearch(false);
      }
    })
  }

  const { fichaCliente, indexCliente, datosContrato, fichaNuevaPoliza, } = sectionDirectory

  let clienteParentState = {}
  let clienteObjState = {};

  if(typeof fichaCliente !== 'undefined'){
    clienteParentState = fichaCliente.parent;
    clienteObjState = fichaCliente.child;
  }

  let [clienteParent,setClienteParent] = useState([clienteParentState]);
  let [clienteObj,setClienteObj] = useState([clienteObjState]);

  useEffect(() => {
    setClienteParent(clienteParentState)
    if(typeof fichaCliente !== 'undefined'){
      let newObj = fichaCliente.child.map( element => {
        return {
          'id_padre' : element.id_padre,
          'valor' : element.dato
        }
      })
      setClienteObj(newObj)
    }
  },[fichaCliente])

  // console.log(fichaNuevaPoliza)

  return(
    <div className="container-fluid">
      <div className="ws-main-container" style={{paddingLeft:'209px',paddingTop:'59px'}}>
        <Container fluid>
          {/* La segmentación del row system está mal, debe corregirse a la actual en producción */}
          <Row>
            
            {/* Lista de clientes */}
            <Col md={3} style={{ backgroundColor:'#fff',borderRight:'1px solid #e3e3e3'}} className="pt-3">
              {/* Vista de búsqueda */}
              <Row>

                <Col xs={12}> 
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <a className={`nav-link ${ (sectionDirectory.view==='clientes') && 'active' }`} aria-current="page" href="#" 
                      onClick={() => {
                        sectionDirectory.view = 'clientes';
                        setSectionDirectory({...sectionDirectory})
                      }} >
                        Clientes
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className={`nav-link ms-2 ${ (sectionDirectory.view==='polizas') && 'active' }`} href="#" 
                      onClick={() => {
                        sectionDirectory.view = 'polizas';
                        setSectionDirectory({...sectionDirectory})
                      }} >
                        Pólizas
                      </a>
                    </li>
                  </ul>
                </Col>

                {
                  sectionDirectory.view === 'clientes'
                  ? (
                    <>
                      {/* AGREGAR UN NUEVO CLIENTE */}
                      <Col xs={12}>
                      {
                        !formNewClient.register
                        ? <p className={classes.newClient} onClick={() => { setOpenRegisterNewClient() }}><i className="bi bi-person-plus-fill"></i>
                        &nbsp;Registrar cliente</p>
                        : <p className={classes.newClient} onClick={() => { setFormNewClient({register: false,}) }}><i className="bi bi-x"></i>&nbsp;Cancelar registro</p>
                      }
                      </Col>
                      
                      {/* BUSCADOR DE CLIENTES */}
                      <Col xs={12} className="mb-4">
                        <Form onSubmit={ (e) => e.preventDefault() }>
                          <Form.Group className="group-search">
                            <i className="bi bi-search pe-2"></i>
                            <Form.Control 
                            type="search"
                            className="ws-input-search"
                            placeholder="Buscar un cliente..."
                            value={sectionDirectory.value}
                            onKeyPress={onChangeSearchClient}
                            onChange={ (ev) => {
                              setSectionDirectory({
                                ...sectionDirectory,
                                value: ev.target.value,
                                results: true,
                                indexCliente: -1,
                              })
                            }}
                            />
                          </Form.Group>
                        </Form>
                      </Col>
                    
                      {/* LISTAR RESULTADO DE AGENTES */}
                      {
                        !sectionDirectory.results
                        ? <p className={classes.newClient}>No se encontraron resultados al buscar <b>{sectionDirectory.value}</b></p>
                        : null
                      }

                      <Col xs={12}> 
                        <div className='ws-directory-list'>
                        {
                          (initSearch) ?
                            <div className='text-center w-100'>
                              <div className={`spinner ${classes.SpinnerColor}`} style={{margin:'20px auto'}}></div>
                            </div>
                          :
                            sectionDirectory.results && sectionDirectory.arr.map((item, index) => (
                              <Row 
                              className={`ws-directory-list-item ${(sectionDirectory.indexCliente === index) && classes.ListItemActive}`}
                              key={`key-cliente-${index}`} 
                              onClick={() => { setSelectCliente(index) }}>
                                <Col md={10}>
                                  <div className='ws-directory-list-item-name'>
                                    <p className={`mb-2 ${classes.NombreCliente}`}>{item.nombre}</p>
                                  </div>
                                  <p className='mb-0 ws-directory-list-item-email'>{item.email}</p>
                                  <p className='mb-0 ws-directory-list-item-phone'>{item.phone}</p>
                                </Col>
                                <Col md={2} className="d-flex align-items-center justify-content-center">
                                  <div className="ws-directory-sidebar-list-badge">
                                    <p className={classes.ListBadge}>{item.polizas}</p>
                                  </div>
                                </Col>
                              </Row>
                            ))
                        }
                        </div>
                      </Col>
                    
                    </>
                  )
                  : null
                }
              </Row>

            </Col>

            {/* Datos póliza */}
            <Col md={ minimizeSidebar ? 7 : 6 } className={`ws-datos-poliza ${classes.DataColumn}`} style={{ paddingBottom: '100px', backgroundColor:'#fff' }}>
              {/* Vista de información */}

              <Row>
              { formNewClient.register ? <p style={{fontWeight:'700'}} className={`d-flex justify-content-start align-items-center ${classes.push} ${classes.CloseButton}`} onClick={() => { setFormNewClient({register: false,}) }}><i className={`material-icons ${classes.ColorIcon}`} >close</i>&nbsp;Cancelar registro</p> : null }
              </Row>

              {
                /**
                * Si el usuario no ha elegido "registrar nuevo cliente"
                * && No ha seleccionado un ramo
                * && No ha seleccionado una póliza para visualizar
                * && Ya seleccionó un cliente de los resultados mostrados
                * && Ya se almacenó información en la fichaCliente (response from fetch)
                */
                !formNewClient.register && !sectionDirectory.fichaRamo && !sectionDirectory.datosContrato && indexCliente > -1 && sectionDirectory.fichaCliente ? (
                  <>
                    <Row className="p-3">
                      <Col md={2}>
                        <img className={`ws-directory-img-profile ${classes.ProfileImage}`} alt={''} style={{ width: '100%', objectFit: 'contain', }} src={'https://acyn.wsoft.com.mx/agentes/img/profile.png'} />
                      </Col>
                      <Col>
                        <p className={`mb-0 ws-directory-profile-name ${classes.ProfileName}`}>{fichaCliente.parent.nombre} {fichaCliente.parent.paterno} {fichaCliente.parent.materno}</p>
                        <p className='mb-0 ws-directory-profile-type'>{sectionDirectory.arr[indexCliente].tipo}</p>
                        <p className='mb-0 ws-directory-creator-type'>{sectionDirectory.arr[indexCliente].creador}</p>
                        <p className={`mb-1 ${classes.push}`}
                          onClick={() => { setDeleteCliente() }}
                        >
                          <i className={`material-icons ws-directory-profile-delete ${classes.push} ${classes.ProfileDeleteIcon}`} >restore_from_trash</i></p>
                        <p className={`mb-0 ws-export-polizas-profile ${classes.push}`}
                          onClick={() => { setDownloadXLS() }}
                        >Exportar pólizas</p>

                      </Col>
                    </Row>
                    <Row className="p-3">

                      <div className={`d-flex justify-content-start align-items-center ws-directory-profile-separator ${classes.ProfileSeparator}`}>
                        <i className="material-icons" style={{fontSize:'40px',marginRight:15}}>art_track</i>
                        <p className='mb-0 banner-title'>Ficha de cliente</p>

                        {
                          (!sectionDirectory.editCliente) ?
                          <i className={`material-icons write ${classes.ProfileSeparatorIcon}`}
                          onClick={
                            () => {
                              setSectionDirectory({
                                ...sectionDirectory,
                                editCliente: true
                              })
                            }
                          } 
                          >create</i>
                          :
                          <i className={`material-icons write ${classes.ProfileSeparatorIcon}`}
                          onClick={
                            () => {
                              setSectionDirectory({
                                ...sectionDirectory,
                                editCliente: false
                              })
                              handleSaveFichaCliente();
                            }
                          } 
                          >done</i>
                        }

                      </div>

                      <Row className="ws-directory-description-cliente">
                        <Col md={4}>
                          <p className='mb-0'>Nombre</p>
                        </Col>
                        <Col>
                        {
                          (sectionDirectory.editCliente) ?
                          <Form.Control 
                          name="nombre" 
                          placeholder="Nombre del cliente" 
                          value={clienteParent.nombre}
                          onChange={
                            (e) => {
                              const { name, value } = e.target;
                              setClienteParent( {...clienteParent, ...{ [name] : value } } )
                            }
                          }
                          />
                          : <p className='mb-0 ws-description-info'>{fichaCliente.parent.nombre}</p>
                        }
                        </Col>
                      </Row>

                      <Row className="ws-directory-description-cliente">
                        <Col md={4}>
                          <p className='mb-0'>Apellido Paterno</p>
                        </Col>
                        <Col>
                        {
                          (sectionDirectory.editCliente) ?
                          <Form.Control 
                          name="paterno" 
                          placeholder="Apellido paterno del cliente" 
                          value={clienteParent.paterno}
                          onChange={
                            (e) => {
                              const { name, value } = e.target;
                              setClienteParent( {...clienteParent, ...{ [name] : value } } )
                            }
                          }
                          />
                          : <p className='mb-0 ws-description-info'>{fichaCliente.parent.paterno}</p>
                        }
                        </Col>
                      </Row>

                      <Row className="ws-directory-description-cliente">
                        <Col md={4}>
                          <p className='mb-0'>Apellido Paterno</p>
                        </Col>
                        <Col>
                        {
                          (sectionDirectory.editCliente) ?
                          <Form.Control 
                          name="materno" 
                          placeholder="Apellido materno del cliente" 
                          value={clienteParent.materno}
                          onChange={
                            (e) => {
                              const { name, value } = e.target;
                              setClienteParent( {...clienteParent, ...{ [name] : value } } )
                            }
                          }
                          />
                          : <p className='mb-0 ws-description-info'>{fichaCliente.parent.materno}</p>
                        }
                        </Col>
                      </Row>
                      
                      <Row className="ws-directory-description-cliente">
                        <Col md={4}>
                          <p className='mb-0'>Teléfono</p>
                        </Col>
                        <Col>
                        {
                          (sectionDirectory.editCliente) ?
                          <Form.Control 
                          name="phone" 
                          placeholder="Ingresa el número de teléfono" 
                          value={clienteParent.phone}
                          onChange={
                            (e) => {
                              const { name, value } = e.target;
                              setClienteParent( {...clienteParent, ...{ [name] : value } } )
                            }
                          }
                          />
                          : <p className='mb-0 ws-description-info'>{fichaCliente.parent.phone}</p>
                        }
                        </Col>
                      </Row>

                      <Row className="ws-directory-description-cliente">
                        <Col md={4}>
                          <p className='mb-0'>Correo electrónico</p>
                        </Col>
                        <Col>
                        {
                          (sectionDirectory.editCliente) ?
                          <Form.Control  
                          name="email"
                          placeholder="Ingresa un correo electrónico" 
                          value={clienteParent.email}
                          onChange={
                            (e) => {
                              const { name, value } = e.target;
                              setClienteParent( {...clienteParent, ...{ [name] : value } } )
                            }
                          }
                          />
                          : <p className='mb-0 ws-description-info'>{fichaCliente.parent.email}</p>
                        }
                        </Col>
                      </Row>
                      <Row className="ws-directory-description-cliente">
                        <Col md={4}>
                          <p className='mb-0'>Fecha de nacimiento</p>
                        </Col>
                        <Col>
                        {
                          (sectionDirectory.editCliente) ?
                          <Form.Control 
                          name="birthday"
                          type="date" 
                          value={clienteParent.birthday} 
                          onChange={
                            (e) => {
                              const { name, value } = e.target;
                              setClienteParent( {...clienteParent, ...{ [name] : value } } )
                            }
                          }
                          />
                          : <p className='mb-0 ws-description-info'>{fichaCliente.parent.birthday}</p>
                        }
                        </Col>
                      </Row>

                      {
                        sectionDirectory.fichaCliente.child.map((item, index) => (
                          <Row className="ws-directory-description-cliente" key={`key-child-${index}`}>
                            <Col md={4}>
                              <p className='mb-0'>{item.nombre}</p>
                            </Col>
                            <Col>
                              {
                                (sectionDirectory.editCliente) ?
                                <Form.Control 
                                name={item.id_padre}
                                value={clienteObj.filter( element => element.id_padre === item.id_padre)[0].valor}
                                onChange={
                                  (e) => {
                                    const { name, value } = e.target;
                                    const newState = [...clienteObj]
                                    newState.map((t,e) => {
                                      if(t.id_padre===item.id_padre){
                                        t.valor = value
                                      }
                                    })
                                    setClienteObj(newState)
                                  }
                                }
                                />
                                : <p className='mb-0 ws-description-info'>{item.dato === '' ? 'Sin descripción' : item.dato}</p>
                              }
                            </Col>
                          </Row>
                        ))
                      }

                    </Row>
                  </>
                ) : null
              }

              {
                formNewClient.register ? (
                  <>
                    <Row>
                      <Col xs={12}>
                        <h4>Ficha de cliente</h4>
                        <Row className="mb-2">
                          <Col md={4}><p>Nombre</p></Col>
                          <Col>
                            <input className={'form-control'}
                              onChange={(ev) => {
                                formNewClient.nombre = ev.target.value;
                                setFormNewClient({...formNewClient,})
                              }}
                              value={formNewClient.nombre} type={'text'} />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col md={4}><p>Apellido Paterno</p></Col>
                          <Col>
                            <input className={'form-control'}
                              onChange={(ev) => {
                                formNewClient.paterno = ev.target.value;
                                setFormNewClient({...formNewClient,})
                              }}
                              value={formNewClient.paterno} type={'text'} />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col md={4}><p>Apellido Materno</p></Col>
                          <Col>
                            <input className={'form-control'}
                              onChange={(ev) => {
                                formNewClient.materno = ev.target.value;
                                setFormNewClient({...formNewClient,})
                              }}
                              value={formNewClient.materno} type={'text'} />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col md={4}><p>Teléfono</p></Col>
                          <Col>
                            <input className={'form-control'}
                              onChange={(ev) => {
                                formNewClient.phone = ev.target.value;
                                setFormNewClient({...formNewClient,})
                              }}
                              value={formNewClient.phone} type={'text'} />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col md={4}><p>Correo electrónico</p></Col>
                          <Col>
                            <input className={'form-control'}
                              onChange={(ev) => {
                                formNewClient.email = ev.target.value;
                                setFormNewClient({...formNewClient,})
                              }}
                              value={formNewClient.email} type={'text'} />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col md={4}><p>Fecha de nacimiento</p></Col>
                          <Col>
                            <input className={'form-control'}
                              onChange={(ev) => {
                                formNewClient.birthday = ev.target.value;
                                setFormNewClient({...formNewClient,})
                              }}
                              value={formNewClient.birthday} type={'text'} />
                          </Col>
                        </Row>
                        {
                          formNewClient.inputs && formNewClient.inputs.map((item, index) => (
                            <Row className="mb-2" key={`key-inputsregister-${index}`}>
                              <Col md={4}>
                                <p>{item.nombre}</p>
                              </Col>
                              <Col>
                                <input className={'form-control'}
                                  onChange={(ev) => {
                                    formNewClient.inputs[index].valor = ev.target.value;
                                    setFormNewClient({...formNewClient,})
                                  }}
                                value={item.valor} type={'text'} />
                              </Col>
                            </Row>
                          ))
                        }
                        <Row clasName="mt-3">
                          <Col md={4}></Col>
                          <Col><Button className={'ws-btn-blue-2'} onClick={() => { setRegisterNewClient() }}>Registrar cliente</Button></Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                ) : null
              }

              {
                /**
                * Si el usuario no ha elegido "registrar nuevo cliente"
                * && Y ya tiene un ramo elegido (obtener tabla de pólizas)
                * && aún no ha elegido ver una póliza
                */
                !formNewClient.register && sectionDirectory.fichaRamo && !sectionDirectory.datosContrato ? (
                  <>
                    <Row className='p-3'>

                      <Col xs={12} md={8} className="mb-3">
                        <h4>Pólizas de <b>{fichaCliente.parent.nombre}</b></h4>
                      </Col>
                    
                      <Col xs={12} md={4} className=" mb-3 text-end">
                        <button 
                        className={`btn btn-primary ws-btn-secondary ${classes.push} ${classes.BtnPrimary}`} 
                        onClick={() => { 
                          setRegistrarNuevaPoliza();
                          handleShowRightSidebar();
                        }}
                        >Registrar póliza</button>
                      </Col>
                      

                      <Col xs={12}> 
                        <Row className='pt-3'>
                          <Col className={`text-center ${tabContratos===1 ? 'active' : ''} ${classes.TabsPolizasBoxLeft}`} onClick={() => { setTabContratos(1); setSelectRamo( sectionDirectory.indexRamo, true, 1 ) }}>
                            <b className={`${classes.TabsPolizasText} ${tabContratos === 1 ? 'active' : ''}`}>Vigentes</b>
                          </Col>
                          <Col className={`text-center ${tabContratos===0 ? 'active' : ''} ${classes.TabsPolizasBoxRight}`} onClick={() => { setTabContratos(0); setSelectRamo( sectionDirectory.indexRamo, true, 0 ) }}>
                            <b className={`${classes.TabsPolizasText} ${tabContratos === 0 ? 'active' : ''}`}>Otros</b>
                          </Col>
                        </Row>
                      </Col>

                      {/* [EM] Hacer funcional el buscador */}

                      <Form onSubmit={ (e) => e.preventDefault() }>
                        <Form.Group className="group-search">
                          <i className="bi bi-search pe-2"></i>
                          <Form.Control 
                          type="search"
                          className="ws-input-search mb-3 mt-3"
                          placeholder="Buscar por contrato, compañía, costo, etc."
                          />
                        </Form.Group>
                      </Form>

                      {/* <input type="text" placeholder={'Buscar por contrato, compañía, costo, etc.'} /> */}

                      <Col xs={12}>
                        <Row className='mb-2 ws-directory-ramos-th'>
                          <Col><b>Número</b></Col>
                          <Col><b>Fechas</b></Col>
                          <Col><b>Compañia</b></Col>
                          <Col><b>Costo</b></Col>
                          <Col><b>Más</b></Col>
                        </Row>                       
                      </Col>

                      {
                        sectionDirectory.fichaRamo.map((item, index) => (
                          <Col xs={12} key={`key-ficharamo-${index}`}>
                            <Row className="ws-directory-ramos-table-info" key={`key-ramo-${index}`}>
                              <Col>
                                <p className={classes.p}>{item.numero_poliza}</p>
                                <p className={classes.p}>
                                  {
                                    item.status === 1
                                      ? 'Vigente'
                                    : item.status === 0
                                      ? 'Cancelada'
                                    : item.status === 2
                                      ? 'Renovada'
                                    : item.status === 3
                                      ? 'No renovada'
                                    : ''
                                  }
                                </p>
                              </Col>
                              <Col>
                                <p className={classes.p}>{item.fecha_inicio}</p>
                                <p className={classes.p}>{item.fecha_fin}</p>
                              </Col>
                              <Col>
                                <p className={classes.p}>{item.compania}</p>
                              </Col>
                              <Col>
                                <p className={classes.p}>${ nf(item.prima_total) }</p>
                                <div className='ws-directory-barProgressPay'>
                                  <div style={{ height: '5px', width: ` ${( item.sum ? (item.sum / item.prima_total) * 100 : 0 )}% `, backgroundColor: 'rgb(0,248,94)', borderRadius: 4, }}></div>
                                </div>
                              </Col>

                              <Col>
                                <nav className="ws-list-dropdown">        
                                  <ul>          
                                    <li className={classes.OptionList} style={{position:'relative',listStyle:'none'}}>
                                      <a href="##">
                                        <i className={`material-icons ${classes.MenuIconList}`} >more_horiz</i>
                                      </a>            
                                      <ul className={classes.SubMenuList}>              
                                        <li className={classes.SubMenuListItem}>
                                          <p style={{margin:'0'}} onClick={ () => { setVerPagos(index) } } >
                                            <i className={`material-icons ${classes.MenuIconSubList}`}>format_list_numbered</i>
                                            Ver pagos
                                          </p>
                                        </li>              
                                        <li className={classes.SubMenuListItem}>
                                          <p style={{margin:'0'}} onClick={ () => { setCancelar(1, index) } } >
                                            <i className={`material-icons ${classes.MenuIconSubList}`}>clear</i>
                                            Cancelar
                                          </p>
                                        </li>  
                                        <li className={classes.SubMenuListItem}>
                                          <p style={{margin:'0'}} onClick={ () => { setRenovar(index) } } >
                                            <i className={`material-icons ${classes.MenuIconSubList}`}>autorenew</i>
                                            Renovar
                                          </p>
                                        </li>          
                                      </ul>          
                                    </li>       
                                  </ul>      
                                </nav>
                                {/* <p style={{margin:'0'}} onClick={ () => { setRenovar(index) } } >Renovar</p> */}
                                {/*<p className={classes.p}>Notificar renovación</p>*/}
                              </Col>
                            </Row>
                          </Col>

                        ))
                      }



                    </Row>
                  </>
                ) : null
              }

              {
                /**
                * Si el usuario no ha elegido "registrar nuevo cliente"
                * && Eligió ver una póliza
                */
                !formNewClient.register && sectionDirectory.datosContrato ? (
                  <>
                    <Row>
                      <p style={{fontWeight:'700'}} className={`d-flex justify-content-start align-items-center ${classes.push} ${classes.CloseButton}`} onClick={() => {
                        delete sectionDirectory.datosContrato
                        setSectionDirectory({
                          ...sectionDirectory,
                        })
                      }}> <i className={`material-icons ${classes.ColorIcon}`} >close</i> Cerrar</p>
                      {/* [EM] Falta hacer una función para que se pueda actualizar el número de póliza, servicio hecho en POSTMAN "Directorio/Actualizar número de póliza" */}
                      <h4 className='text-center mb-4'>Póliza {sectionDirectory.datosContrato.configuracion.numero_poliza}</h4>


                      {/* <Col xs={12}> 
                        <Row className='pt-3'>
                          <Col className={`text-center ${tabContratos===1 ? 'active' : ''} ${classes.TabsPolizasBoxLeft}`} onClick={() => { setTabContratos(1); setSelectRamo( sectionDirectory.indexRamo, true, 1 ) }}>
                            <b className={`${classes.TabsPolizasText} ${tabContratos === 1 ? 'active' : ''}`}>Vigentes</b>
                          </Col>
                          <Col className={`text-center ${tabContratos===0 ? 'active' : ''} ${classes.TabsPolizasBoxRight}`} onClick={() => { setTabContratos(0); setSelectRamo( sectionDirectory.indexRamo, true, 0 ) }}>
                            <b className={`${classes.TabsPolizasText} ${tabContratos === 0 ? 'active' : ''}`}>Otros</b>
                          </Col>
                        </Row>
                      </Col> */}

                      <Col xs={12}> 
                        <Row className='p-3'>
                          <Col onClick={() => { setTabPoliza(1); }} className={`text-center ${tabPoliza === 1 ? 'active' : ''} ${classes.TabsPolizasBoxLeft}`} >
                            <b className={`${classes.TabsPolizasText} ${tabPoliza === 1 ? 'active' : ''}`}>Detalles</b>
                          </Col>
                          <Col onClick={() => { setTabPoliza(2); }} className={`text-center ${tabPoliza === 2 ? 'active' : ''} ${classes.TabsPolizasBoxRight}`} >
                            <b className={`${classes.TabsPolizasText} ${tabPoliza === 2 ? 'active' : ''}`}>Recibos</b>
                          </Col>
                        </Row>
                      </Col>

                      {
                        tabPoliza === 1 ? (
                        <>
                          <h5 className={classes.TitleViewDetail}>Ficha</h5>
                            <hr />
                            <Row>
                              <Col md={4}><p>Cliente</p></Col>
                              <Col><b>{datosContrato.configuracion.nombre_cliente}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Teléfono</p></Col>
                              <Col><b>{datosContrato.configuracion.telefono_cliente}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Correo electrónico</p></Col>
                              <Col><b>{datosContrato.configuracion.email_cliente}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Estado</p></Col>
                              <Col><b>
                              {
                                datosContrato.configuracion.status === 1
                                  ? 'Vigente'
                                : datosContrato.configuracion.status === 0
                                  ? 'Cancelada'
                                : datosContrato.configuracion.status === 2
                                  ? 'Renovada'
                                : datosContrato.configuracion.status === 3
                                  ? 'No renovada'
                                : ''
                              }
                              </b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Inicia</p></Col>
                              <Col><b>{datosContrato.configuracion.fecha_inicio}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Vence</p></Col>
                              <Col><b>{datosContrato.configuracion.fecha_fin}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Forma de pago</p></Col>
                              <Col><b>{datosContrato.configuracion.numero_renovacion}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Concepto de pago</p></Col>
                              <Col><b>
                              {
                                datosContrato.configuracion.forma_pago === 'e'
                                ? 'Efectivo'
                                : 'Cargo a tarjeta'
                              }
                              </b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Moneda</p></Col>
                              <Col><b>{datosContrato.configuracion.moneda === 'mxn' ? 'Peso mexicano' : 'Dolar'}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Compañía</p></Col>
                              <Col><b>{datosContrato.configuracion.compania}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Ramo</p></Col>
                              <Col><b>{datosContrato.configuracion.ramo}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Creador</p></Col>
                              <Col><b>{datosContrato.configuracion.nombre_creador}</b></Col>
                            </Row>
                            <Row>
                              <Col md={4}><p>Fecha</p></Col>
                              <Col><b>{datosContrato.configuracion.fecha}</b></Col>
                            </Row>

                            <h5 className={classes.TitleViewDetail}>Extra</h5>
                            <p className={classes.push} onClick={() => { setEditPolizaExtra() }}>{!datosContrato.editExtra ? 'Editar' : 'Guardar cambios'}</p>
                            <hr />
                            {
                              datosContrato.extra && datosContrato.extra.map((item, index) => (
                                <Row key={`key-inputsregister-${index}`}>
                                  <Col md={4}>
                                    <p>{item.padre}</p>
                                  </Col>
                                  <Col>
                                    {
                                      datosContrato.editExtra ? (
                                        <input className={'form-control'}
                                          onChange={(ev) => {
                                            datosContrato.extra[index].nombre = ev.target.value;
                                            setSectionDirectory({...sectionDirectory,})
                                          }}
                                        value={item.nombre} type={'text'} />
                                      ) : <b>{item.nombre}</b>
                                    }
                                  </Col>
                                </Row>
                              ))
                            }

                          <h5 className={classes.TitleViewDetail}>Nube</h5>
                          {/* [EM] Falta upload de pólizas consumo en POSTMAN */}
                          <p className={classes.push}>Subir</p>
                          <hr />
                          {
                            datosContrato.nube && datosContrato.nube.map((item, index) => (
                              <Row key={`key-inputsregister-${index}`}>
                                <Col md={2}>
                                  <p>Logo</p>
                                </Col>
                                <Col md={6}>
                                  <p>{item.nombre}</p>
                                  <p>{item.fecha}</p>
                                </Col>
                                <Col>
                                  <p onClick={() => { setDeleteNubePoliza(index) }}>Eliminar</p>
                                  <p onClick={() => { setDownloadNube(index) }}>Descargar</p>
                                </Col>
                              </Row>
                            ))
                          }
                          
                          <h5 className={classes.TitleViewDetail}>Observaciones</h5>
                          <p className={classes.push} onClick={() => { setEditPolizaObservacion() }}>{!datosContrato.editObservaciones ? 'Editar' : 'Guardar cambios'}</p>
                          <hr />
                          {
                            datosContrato.editObservaciones ? (
                              <textarea className={'form-control'}
                                onChange={(ev) => {
                                  datosContrato.configuracion.observacion = ev.target.value;
                                  setSectionDirectory({...sectionDirectory,})
                                }}
                              value={datosContrato.configuracion.observacion} type={'text'}></textarea>
                            ) : <b>{datosContrato.configuracion.observacion}</b>
                          }

                          <h5 className={classes.TitleViewDetail}>Agentes compartidos</h5>
                          <p className={classes.push} onClick={() => { alert('Desarrollar este módulo') }}>{!datosContrato.editAgentes ? 'Editar' : 'Guardar cambios'}</p>
                          <hr />


                        </>
                        ) : (
                          <>
                            <h5 className={classes.TitleViewDetail}>Primas</h5>
                            <hr />

                            <Col xs={12}>
                              <Row>
                                <Col md={4}>
                                  <Row>
                                    <p className={classes.TitleTableDetail}>PRIMA TOTAL</p>
                                    <b className={classes.PriceTableDetail}>${datosContrato.configuracion.prima_total}</b>
                                    <b className={classes.MonedaTableDetail}>MXN</b>
                                  </Row>
                                </Col>
                                <Col md={4}>
                                  <Row>
                                    <p className={classes.TitleTableDetail}>PRIMA NETA</p>
                                    <b className={classes.PriceTableDetail}>${datosContrato.configuracion.prima_neta}</b>
                                    <b className={classes.MonedaTableDetail}>MXN</b>
                                  </Row>
                                </Col>
                                <Col md={4}>
                                  <Row>
                                    <p className={classes.TitleTableDetail}>PRIMA ABONADA</p>
                                    <b className={classes.PriceTableDetail}>${datosContrato.configuracion.abonado}</b>
                                    <b className={classes.MonedaTableDetail}>MXN</b>
                                  </Row>
                                </Col>
                              </Row>
                            </Col> 

                            <h5 className={`mt-4 ${classes.TitleViewDetail}`}>Endosos</h5>
                            <hr />

                            <Row>
                              <Col><p className={classes.TitleTableDetail}>#</p></Col>
                              <Col><b className={classes.TitleTableDetail}>Fecha inicial</b></Col>
                              <Col><p className={classes.TitleTableDetail}>Total</p></Col>
                              <Col><p className={classes.TitleTableDetail}>Recibo inicial</p></Col>
                            </Row>
                            <Row>
                              <p>Terminar módulo</p>
                            </Row>

                            <h5 className={`mt-4 ${classes.TitleViewDetail}`}>Recibos</h5>
                            <hr />

                            <Row>
                              <Col md={1}><p>#</p></Col>
                              <Col><b className={classes.TitleTableDetail}>Mes</b></Col>
                              <Col><p className={classes.TitleTableDetail}>Prima</p></Col>
                              <Col><p className={classes.TitleTableDetail}>Abonado</p></Col>
                              <Col><p className={classes.TitleTableDetail}>Estado</p></Col>
                              <Col><p className={classes.TitleTableDetail}>Opciones</p></Col>
                            </Row>
                            <Row>
                              {
                                datosContrato.contratos.map((item, index) => (
                                  <Row key={`key-recibos-${index}`}>
                                    <Col md={1}><b className={classes.TextTableDetail}>{item.contador}</b></Col>
                                    <Col><p className={classes.TextTableDetail}>{item.mes}</p></Col>
                                    <Col><p className={classes.TextTableDetail}>${nf(item.pago)}</p></Col>
                                    <Col><p className={classes.TextTableDetail}>${nf(item.abonos)}</p></Col>
                                    <Col>
                                      {
                                        item.estado === 1
                                          ? <p className={classes.LabelTagSuccess}>Pagado</p>
                                        : item.estado === 0
                                          ? <p className={classes.LabelTagDanger}>Sin Pagar</p>
                                        : item.estado === 2
                                          ? <p className={classes.LabelTagWarning}>Pendiente</p>
                                        : ''
                                      }
                                    </Col>
                                    <Col>

                                    <nav className="ws-list-dropdown">        
                                      <ul>          
                                        <li className={classes.OptionList} style={{position:'relative',listStyle:'none'}}>
                                          <a href="##">
                                            <i className={`material-icons ${classes.MenuIconList}`} >more_horiz</i>
                                          </a>            
                                          <ul className={classes.SubMenuList}>   

                                            {
                                              item.estado === 1 ?
                                              <li className={classes.SubMenuListItem}>
                                                <p style={{margin:'0'}} onClick={() => { setPolizaMarcaPago(index) }} >
                                                  <i className={`material-icons ${classes.MenuIconSubList}`}>clear</i>
                                                  Desmarcar Pago
                                                </p>
                                              </li>  
                                              : 
                                              <li className={classes.SubMenuListItem}>
                                                <p style={{margin:'0'}} onClick={() => { setPolizaMarcaPago(index) }} >
                                                  <i className={`material-icons ${classes.MenuIconSubList}`}>check</i>
                                                  Marcar Pago
                                                </p>
                                              </li>
                                            }

                                          </ul>          
                                        </li>       
                                      </ul>      
                                    </nav>
                                      {/* <p onClick={() => { setPolizaMarcaPago(index) }} className={classes.p}>{item.estado === 1 ? 'Desmarcar pago' : 'Marcar pago'}</p> */}
                                      {
                                        /*
                                        <p className={classes.p}>Modificar prima</p>
                                        <p className={classes.p}>Fecha de pago</p>
                                        <p className={classes.p}>Observación</p>
                                        */
                                      }
                                    </Col>
                                  </Row>

                                ))
                              }
                            </Row>

                          </>
                        )
                      }


                    </Row>
                  </>
                ) : null
              }

            </Col>
            
            {/* Lista ramos */}
            <Col md={ minimizeSidebar ? 2 : 3 } className={`d-flex flex-column grid-directory-ramos pt-2`} style={{ minHeight:'100vh', position:'relative', borderLeft: '1px solid #e3e3e3' }}>

              <h3 style={{color:'#444',fontSize:'1.7rem'}}>Ramos</h3>

              { minimizeSidebar && ( <div className={`${classes.ExpandIcon}`} onClick={ () => setMinimizeSidebar(false)} ></div> ) }

              {
                indexCliente > -1 && sectionDirectory.fichaCliente.contratos.map((item, index) => (
                  <Row className={`ws-directory-ramos-list ${(item.selected ? classes.backgroundPrimary : '')}`} 
                  style={{
                    color: (item.selected) && '#fff'
                  }} key={`key-ramos-${index}`}
                    onClick={() => {
                      setSelectRamo(index)
                    }}
                  >
                    <Col md={12}>
                      <div className={`ws-directory-sidebar-list-badge`}><p className={classes.ListBadge}>{item.activo}</p></div>
                    </Col>
                    <Col md={12}>
                      <p className={`ws-ramos-nombre ${classes.RamosListNombre} ${minimizeSidebar ? 'hide' : ''}`}>{item.nombre}</p>
                    </Col>
                  </Row>
                ))
              }
            </Col>

          </Row>

        </Container>
      </div>

      <Modal show={showDeletePoliza.index > -1 ? true : false} onHide={() => {setShowDeletePoliza({ index: -1, })}}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar póliza</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Estás a punto de eliminar un contrato, si aceptas también será borrado su historial de pagos.</p>
            <select
              onChange={(ev) => {
                showDeletePoliza.id_motivo = ev.target.value
                setShowDeletePoliza({...showDeletePoliza})
              }}
            >
              <option disabled={true} selected={true}>Elige una opción</option>
              <option value="1">Venta de vehículo</option>        
              <option value="2">Siniestro</option>        
              <option value="3">Cambio de unidad</option>        
              <option value="4">A solicitud del asegurado</option>        
              <option value="5">Falta de pago</option>        
              <option value="6">Servicio</option>        
              <option value="7">Precio</option>        
              <option value="0">Otro</option>
            </select>
            <textarea className={'form-control'}
              onChange={(ev) => {
                showDeletePoliza.observacion = ev.target.value
                setShowDeletePoliza({...showDeletePoliza})
              }}
              placeholder={'Escribe el motivo de la cancelación...'}
              value={showDeletePoliza.observacion}
            ></textarea>
          
          
          </Modal.Body>
          <Modal.Footer>
            <Row style={{ width: '100%', }}>
              <Col>
                <Button variant="secondary" onClick={() => {setShowDeletePoliza({ index: -1, })}}>Cerrar sin cancelar</Button>
              </Col>
              <Col style={{ textAlign: 'right', }}>
                {
                  showDeletePoliza.id_motivo !== '' ? (
                    <Button
                      onClick={ () => { setCancelar(2, showDeletePoliza.index) } }
                      className={'btn btn-danger'}
                    >Eliminar</Button>
                  ) : null
                }
              </Col>
            </Row>
          </Modal.Footer>
      </Modal>

        {/* SIDEBAR */}
        <RightSidebar title={ fichaNuevaPoliza.renovation === 0 ? 'Registrar nuevo contrato' : `Renovar póliza: ${fichaNuevaPoliza.numero_poliza}`} status={showSidebarRight} setStatus={setShowSidebarRight}>
          {
            // Paso 1, registrar datos del vehículo
            fichaNuevaPoliza.step === 1 ? (
              <>

                <h5 style={{fontSize:'2rem',fontWeight:'800'}}>PASO 1</h5>
                <hr />

                <div className='mb-2'>
                  <p className='ws-newramo-title'>Número de póliza</p>
                  <input className='ws-newramo-input' type={'text'} placeholder={'Ingresa el número de póliza...'}
                    onChange={(ev) => {
                      fichaNuevaPoliza.numero_poliza = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.numero_poliza}
                  />
                </div>

                <div className='mb-2'>
                  <p className='ws-newramo-title'>Fecha inicio de vigencia</p>
                  <input className='ws-newramo-input' type={'date'}
                    onChange={(ev) => {
                      fichaNuevaPoliza.fecha_inicio = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.fecha_inicio}
                  />
                </div>

                <div className='mb-2'> 
                  <p className='ws-newramo-title'>Fecha fin de vigencia</p>
                  <input className='ws-newramo-input' type={'date'}
                    onChange={(ev) => {
                      fichaNuevaPoliza.fecha_fin = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.fecha_fin}
                  />
                </div>

                <div className='mb-2'> 
                  <p className='ws-newramo-title'>Prima total</p>
                  <input className='ws-newramo-input' type={'text'}
                    onChange={(ev) => {
                      fichaNuevaPoliza.prima_total = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.prima_total}
                  />
                </div>

                <div className='mb-2'> 
                  <p className='ws-newramo-title'>Prima neta</p>
                  <input className='ws-newramo-input' type={'text'}
                    onChange={(ev) => {
                      fichaNuevaPoliza.prima_neta = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.prima_neta}
                  />
                </div>

                <div className='mb-2'> 
                  <p className='ws-newramo-title'>Forma de pago</p>
                  <select style={{height:'45px'}} className='ws-newramo-input' onChange={(ev) => {
                      fichaNuevaPoliza.forma_pago = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.forma_pago}
                  >
                    <option value={'0'} disabled={true} selected={true}>Selecciona una opción</option>
                    <option value={'m'}>Mensual</option>
                    <option value={'t'}>Trimestral</option>
                    <option value={'s'}>Semestral</option>
                    <option value={'a'}>Anual</option>
                  </select>
                </div>

                <div className='mb-2'> 
                  <p className='ws-newramo-title'>Concepto</p>
                  <select
                  style={{height:'45px'}}
                    className='ws-newramo-input'
                    onChange={(ev) => {
                      fichaNuevaPoliza.concepto = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.concepto}
                  >
                    <option value={0} disabled={true} selected={true}>Selecciona un concepto</option>
                    <option value={'e'}>Efectivo</option>
                    <option value={'c'}>Cargo a tarjeta</option>
                  </select>
                </div>

                <div className='mb-2'> 
                  <p className='ws-newramo-title'>Compañía</p>
                  <select
                    className='ws-newramo-input'
                    style={{height:'45px'}}
                    onChange={(ev) => {
                      fichaNuevaPoliza.compania = ev.target.value
                      setSectionDirectory({ ...sectionDirectory, })
                    }}
                    value={fichaNuevaPoliza.compania}
                  >
                    <option value={0} disabled={true} selected={true}>Selecciona una compañía</option>
                    {
                      fichaNuevaPoliza.companias.map((item, index) => (
                        <option key={`key-companias-${index}`} value={item.id_compania}>{item.nombre}</option>
                      ))
                    }
                  </select>
                </div>

                <p className='ws-newramo-title mb-4'>Agentes</p>
                {
                  fichaNuevaPoliza.agentes.map((item, index) => (
                    <Row key={`key-listagentes-${index}`} style={{borderBottom:'1px solid #f3f3f3'}}>
                      
                      <Col md={2} className="pt-3 pb-3" onClick={() => {
                        item.selected = !item.selected
                        setSectionDirectory({ ...sectionDirectory, })
                      }}>
                        
                        <p style={{cursor:'pointer'}}>{item.selected 
                          ? <i className="material-icons pointer" id="ws_principal_filter" style={{fontSize:'1.8rem',marginRight:6,color:'#ff355c'}}>check_box</i> 
                          : <i className="material-icons pointer" id="ws_principal_filter" style={{fontSize:'1.8rem',marginRight:6,color:'#777'}}>check_box_outline_blank</i> }</p>
                      </Col>

                      <Col md={10} className="pt-3 pb-3">
                        <p style={{fontSize:'1.2rem',color:'#333',margin:'0px',fontWeight:'600',textTransform:'uppercase'}}>{item.nombre}</p>
                        <p>{item.clave}</p>
                      </Col>
                    </Row>
                  ))
                }

                {
                  fichaNuevaPoliza.forma_pago && fichaNuevaPoliza.concepto && fichaNuevaPoliza.numero_poliza &&
                  fichaNuevaPoliza.fecha_inicio && fichaNuevaPoliza.fecha_fin && fichaNuevaPoliza.prima_total &&
                  fichaNuevaPoliza.prima_neta && fichaNuevaPoliza.compania ? (
                    <Row>
                      <Col className='mt-4 mb-5'>
                        <Button className={`ws-newramo-continue d-flex justify-content-center ${classes.BtnPrimary}`} variant="primary" onClick={() => { setNuevaPolizaStep(2) }}>
                          Continuar
                          <i class="material-icons">arrow_forward</i>
                        </Button>
                      </Col>
                    </Row>
                  ) : null
                }

                
              </>
            ) : null
          }

          {
            // Paso 2, pasar al simulador
            fichaNuevaPoliza.step === 2 ? (
              <>

                <h5 style={{fontSize:'2rem',fontWeight:'800'}}>PASO 2</h5>
                <hr />
                <p onClick={() => {
                  fichaNuevaPoliza.step = 1
                  setSectionDirectory({ ...sectionDirectory, })
                }}>Regresar</p>
                
                {
                  fichaNuevaPoliza.recibos.map((item, index) => (
                    <Row key={`key-fichanewpoliza-${index}`}>
                      {
                        index === 0 ? (
                          <>
                            <Col xs={1}><p className="ws-newramo-countrecipt mb-0">#{item.id}</p></Col>
                            <Col xs={4}>
                              <input className='ws-newramo-input' type={'date'}
                                value={item.fecha}
                              />
                            </Col>
                            <Col xs={4}>
                              <input className='ws-newramo-input' type={'date'}
                                value={item.pgracia}
                                onChange={(ev) => {
                                  item.pgracia = ev.target.value
                                  setSectionDirectory({...sectionDirectory})
                                }}
                              />
                              <p>Periodo de gracia</p>
                            </Col>
                            <Col xs={3}>
                              <input className='ws-newramo-input' type={'text'}
                                onChange={(ev) => {
                                  // Alteramos solo el primer valor
                                  item.valor = ev.target.value
                                  // Ahora recalculamos el resto en primas
                                  const fracciones = ((parseFloat(fichaNuevaPoliza.prima_total) - parseFloat(item.valor)) / (fichaNuevaPoliza.recibos.length - 1))
                                  fichaNuevaPoliza.recibos.map((t,e) => {
                                    if(e > 0)
                                      t.valor = fracciones
                                    return true;
                                  })
                                  setSectionDirectory({...sectionDirectory})
                                }}
                                value={item.valor}
                              />
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col xs={1}><p className="ws-newramo-countrecipt mb-0">#{item.id}</p></Col>
                            <Col xs={5}>
                              <input className='ws-newramo-input' type={'date'}
                                value={item.fecha}
                              />
                            </Col>
                            <Col xs={5}>
                              <p className="mb-0" style={{fontSize:'1.6rem'}}>{item.valor}</p>
                            </Col>
                            <hr className="mt-4" />
                          </>
                        )
                      }
                    </Row>
                  ))
                }

                <h5>Extra</h5>
                <hr />
                {
                  fichaNuevaPoliza.extra && fichaNuevaPoliza.extra.map((item, index) => (
                    <Row key={`key-extra-${index}`} className="mb-3">
                      <Col md={4}>
                        <p>{item.nombre}</p>
                      </Col>
                      <Col>
                        <input className='ws-newramo-input'
                          onChange={(ev) => {
                            fichaNuevaPoliza.extra[index].value = ev.target.value;
                            setSectionDirectory({...sectionDirectory,})
                          }}
                        value={item.value} type={'text'} />
                      </Col>
                    </Row>
                  ))
                }

                <h5>Observación</h5>
                <hr />
                <textarea 
                style={{width:'100%',resize:'none',height:'auto'}}
                rows={4}
                  onChange={(ev) => {
                    fichaNuevaPoliza.observacion = ev.target.value;
                    setSectionDirectory({...sectionDirectory,})
                  }}
                value={fichaNuevaPoliza.observacion}></textarea>

                <Row>
                  <Col className="mt-4 mb-5">
                    <Button className={`ws-newramo-continue d-flex justify-content-center ${classes.BtnPrimary}`} variant="primary" onClick={() => {
                    fichaNuevaPoliza.step = 3
                    setSectionDirectory({ ...sectionDirectory, })
                  }}>
                    Continuar
                    <i class="material-icons">arrow_forward</i>
                    </Button>
                  </Col>
                </Row>
                

              </>
            ) : null
          }

          {
            // Paso 3, pasar a confirmar
            fichaNuevaPoliza.step === 3 ? (
              <>

                <h5 style={{fontSize:'2rem',fontWeight:'800'}}>PASO 3</h5>
                <hr />
                <p style={{
                  padding:'5px',
                  borderRadius:'4px',
                  marginBottom:'20px',
                  color:'#777',
                  cursor:'pointer'
                }} onClick={() => {
                  fichaNuevaPoliza.step = 2
                  setSectionDirectory({ ...sectionDirectory, })
                }}>Regresar</p>
                
                <h6 className="text-center" style={{textTransform:'uppercase',fontWeight:'800',letterSpacing:'2px',fontSize:'1.3rem'}}>Por registrar</h6>
                <Row className='mb-3'>
                  <Col className="ws-text-contrato">Número de contrato</Col>
                  <Col>{fichaNuevaPoliza.numero_poliza}</Col>
                </Row>
                <Row className='mb-3'>
                  <Col className="ws-text-contrato">Fecha inicio de vigencia</Col>
                  <Col>{fichaNuevaPoliza.fecha_inicio}</Col>
                </Row>
                <Row className='mb-3'>
                  <Col className="ws-text-contrato">Fecha fin de vigencia</Col>
                  <Col>{fichaNuevaPoliza.fecha_fin}</Col>
                </Row>
                <Row className='mb-3'>
                  <Col className="ws-text-contrato">Prima total</Col>
                  <Col>{fichaNuevaPoliza.prima_total}</Col>
                </Row>
                <Row className='mb-3'>
                  <Col className="ws-text-contrato">Recibos</Col>
                  <Col>{fichaNuevaPoliza.recibos.length}</Col>
                </Row>
                <Row className='mb-3'>
                  <Col className="ws-text-contrato">Concepto</Col>
                  <Col>{fichaNuevaPoliza.concepto === 'e' ? 'Efectivo' : 'Cargo a tarjeta'}</Col>
                </Row>

                <Row className="mt-4 mb-5">
                  <Col>
                    <Button className={`ws-newramo-continue ${classes.BtnPrimary}`} variant="primary" onClick={() => {
                      
                    }}>Registrar y notificar al cliente</Button>
                  </Col>
                  <Col>
                    <Button className={`ws-newramo-continue ${classes.BtnPrimary}`} variant="primary" onClick={() => {
                      setRegisterNuevaPolizaEnd()
                    }}>Solo registrar</Button>
                  </Col>
                </Row>

              </>
            ) : null
          }
        </RightSidebar>

    </div>
  ) 

  function nf(number) {
    return parseFloat(number).toLocaleString(undefined, { maximumFractionDigits: 2 })
  }

}